import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { CenterVisitAverageRedux } from '../Redux/CenterVisitAverageRedux'

const centerVisitAverageCrudObservable = createCRUDObservable({
  mainRedux: CenterVisitAverageRedux,
  reduxPath: 'centerVisitAverage',
})

export const centerVisitAverageObservers = Object.assign({}, centerVisitAverageCrudObservable.observers, {})

export const centerVisitAverageEpic = combineEpics(
  centerVisitAverageCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CenterVisitAverageObservable.js